/**
 * Past this, waiting on the send stops looking like sending and starts looking stuck. A
 * knob rather than a constant so a test holding a send open can wait in test time rather
 * than in wall-clock time.
 */
export const SEND_TIMING = { timeoutMs: 15_000 }
